import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { createFetcher } from 'dibs-relay-network-layer/client.ts';
import { setupSubscriptions } from 'dibs-relay-network-layer/subscriptionsClient.ts';
import SV from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { getGuestUserToken } from './checkoutGuestUserToken.ts';

type GetEnvironmentOptions = {
    getGraphQLNetworkContext?: () => string | null;
    additionalHeaders?: Record<string, string>;
    storeOptions?: {
        queryCacheExpirationTime?: number | null | undefined;
    };
};

export function getEnvironment({
    getGraphQLNetworkContext,
    additionalHeaders,
    storeOptions,
}: GetEnvironmentOptions = {}): Environment {
    const source = new RecordSource();
    const store = new Store(source, storeOptions);
    const userType = 'buyer';
    const getQueries: () => Record<string, string | undefined> = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const shareToken = searchParams.get('shareToken');
        const buyerToken = getBuyerToken(document.cookie);
        const emailToken = searchParams.get('emailToken') || undefined;

        // guest token takes precedence over email only tokens
        // guest token should not coexist with full account tokens so full account takes precedence if it exists
        const guestUserToken = getGuestUserToken();
        let userToken;
        if (buyerToken.userToken) {
            userToken = buyerToken;
        } else if (guestUserToken) {
            userToken = { userToken: guestUserToken };
        }

        const queries: Record<string, string | undefined> = {
            ...userToken,
            emailToken,
            locale: SV.get('locale'),
        };

        if (shareToken) {
            queries.invoiceAccessToken = shareToken;
        }

        return queries;
    };
    const network = Network.create(
        createFetcher({ userType, getQueries, getGraphQLNetworkContext, additionalHeaders }),
        setupSubscriptions({ getQueries, userType }).fetchOrSubscribe
    );

    return new Environment({
        network,
        store,
    });
}
